// Question-related utility functions and constants

export const QuestionTypes = {
  SINGLE_CHOICE: "single_choice",
  MULTIPLE_CHOICE: "multiple_choice",
  CODING: "coding",
};

export const DifficultyLevels = {
  EASY: 1,
  MEDIUM: 2, 
  HARD: 3,
  VERY_HARD: 4,
};

export const convertDifficultyToColor = (level) => {
  switch (level) {
    case DifficultyLevels.EASY:
      return "#1ABC9C";
    case DifficultyLevels.MEDIUM:
      return "#F1C40F";
    case DifficultyLevels.HARD:
      return "#E67E22";
    case DifficultyLevels.VERY_HARD:
      return "#E74C3C";
    default:
      return "#7F8C8D";
  }
};

export const convertDifficultyToString = (level) => {
  switch (level) {
    case DifficultyLevels.EASY:
      return "Easy";
    case DifficultyLevels.MEDIUM:
      return "Medium";
    case DifficultyLevels.HARD:
      return "Hard";
    case DifficultyLevels.VERY_HARD:
      return "Very Hard";
    default:
      return "Indeterminated";
  }
};

export const getQuestionTypeDisplay = (type) => {
  switch (type) {
    case QuestionTypes.SINGLE_CHOICE:
    case 0:
      return "Single Choice";
    case QuestionTypes.MULTIPLE_CHOICE:
    case 1:
      return "Multiple Choice";
    case QuestionTypes.CODING:
    case 2:
      return "Coding";
    default:
      return "Unknown";
  }
};
